// import { Grid, Button } from "@mui/material";
// import { FileFinepModel } from "../../../../Models/FileFinepModel";
// import UploadInputByDocType from "../../../../Components/RegistrationDocumentsFinep/UploadInputByDocType";
// import { useContext } from "react";
// import { RegistrationDocumentsFinepContext } from "../../../../Contexts/RegistrationDocumentsFinepContext";

// interface StatutoryDocumentsTabProps {
//     files: FileFinepModel[]
// }

// const StatutoryDocumentsTab = ({ files }: StatutoryDocumentsTabProps) => {
//     const { changeTab } = useContext(RegistrationDocumentsFinepContext);

//     return (
//         <>
//             <div className="d-flex justify-content-end mb-4 mt-4">
//                 <Button variant="contained" size="large" disabled >
//                     Notificar
//                 </Button>
//             </div>
//             <Grid container spacing={2}>
//                 <Grid item xs={8}></Grid>
//                 <Grid item xs={2}>
//                     <span className="me-4 ">Validado ?</span>
//                 </Grid>
//                 <Grid item xs={2}>
//                     <span className="me-2">Notificar</span>
//                 </Grid>

//                 <Grid item xs={12}>
//                     <strong className="mt-4 mb-4 blue">Estatuto/ Contrato Social:</strong>
//                 </Grid>
//                 <UploadInputByDocType
//                     docType={4}
//                     files={files}
//                 />

//                 <Grid item xs={12}>
//                     <strong className="mt-4 mb-4 blue">Acordo de Acionistas dos Atuais Dirigentes:</strong>
//                 </Grid>
//                 <UploadInputByDocType
//                     docType={5}
//                     files={files}
//                 />
//             </Grid>

//             <div className="d-flex justify-content-end mt-4 mb-4">
//                 <Button variant="contained" className="me-4" onClick={() => changeTab(2)}>Próxima Etapa</Button>
//                 <Button variant="outlined" onClick={() => changeTab(0)}>Voltar</Button>
//             </div>
//         </>
//     );
// };

// export default StatutoryDocumentsTab;

import { useContext } from "react";
import { FileFinepModel } from "../../../../Models/FileFinepModel";
import UploadInputByDocType from "../../../../Components/RegistrationDocumentsFinep/UploadInputByDocType";
import { RegistrationDocumentsFinepContext } from "../../../../Contexts/RegistrationDocumentsFinepContext";
import { Button, Row, Col, Typography } from "antd";
import "./styles.css";
import { BellOutlined, PlusOutlined } from "@ant-design/icons";
const { Text, Title } = Typography;
interface StatutoryDocumentsTabProps {
    files: FileFinepModel[];
}
const StatutoryDocumentsTab = ({ files }: StatutoryDocumentsTabProps) => {
    const { changeTab } = useContext(RegistrationDocumentsFinepContext);

    return (
        <>
            <div className="header-container">
                <BellOutlined className="notification-icon" />
            </div>
            <Row gutter={[16, 16]} align="middle">
                <Col span={17} />
                <Col span={3} className="text-right">
                    <Text className="label-text">Validado?</Text>
                </Col>
                <Col span={3} className="text-left">
                    <Text className="label-text">Notificar</Text>
                </Col>
                <Col span={24}>
                    <Title level={5} className="section-title">
                        Estatuto/ Contrato Social:
                    </Title>
                </Col>
                <UploadInputByDocType docType={4} files={files} />
                <Col span={24}>
                    <Title level={5} className="section-title">
                        Acordo de Acionistas dos Atuais Dirigentes:
                    </Title>
                </Col>
                <UploadInputByDocType docType={5} files={files} />
            </Row>
            <div className="button-container">
                <Button onClick={() => changeTab(0)}>Voltar</Button>
                <Button type="primary" onClick={() => changeTab(2)}>
                    <PlusOutlined /> Próxima Etapa
                </Button>
            </div>
        </>
    );
};
export default StatutoryDocumentsTab;